<template>
  <v-layout row>
    <v-flex :class="flexClass">
      <v-layout v-if="showLabel">
        <v-flex xs12 font-weight-bold>
          {{ labelText }}<span class="attention"> (必須)</span>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 md6 :style="{ order: locale === 'en' ? 1 : 2 }">
          <v-text-field
            name="first_name"
            type="text"
            :label="firstNameLabel"
            required
            v-model="first_name"
            :error-messages="
              errorMessages && errorMessages.first_name
                ? errorMessages.first_name
                : ''
            "
            @input="
              $emit('update-name', {
                last_name: last_name,
                first_name: first_name,
              })
            "
          ></v-text-field>
        </v-flex>

        <v-flex xs12 md6 :style="{ order: locale === 'en' ? 2 : 1 }">
          <v-text-field
            name="last_name"
            type="text"
            :label="lastNameLabel"
            required
            v-model="last_name"
            :error-messages="
              errorMessages && errorMessages.last_name
                ? errorMessages.last_name
                : ''
            "
            @input="
              $emit('update-name', {
                last_name: last_name,
                first_name: first_name,
              })
            "
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    labelText: {
      type: String,
      default: "ご氏名",
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    locale: {
      type: String,
      required: true,
      default: "ja",
    },
    variant: {
      type: String,
      default: "default",
      validator: (value) => ["default", "wide"].includes(value),
    },
    initialLastName: {
      type: String,
      default: "",
    },
    initialFirstName: {
      type: String,
      default: "",
    },
    errorMessages: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    flexClass() {
      return this.variant === "wide" ? "xs12 md12" : "xs12 md6";
    },
    firstNameLabel() {
      return this.locale === "en" ? "First Name*" : "名*";
    },
    lastNameLabel() {
      return this.locale === "en" ? "Last Name*" : "姓*";
    },
  },
  data() {
    return {
      last_name: this.initialLastName,
      first_name: this.initialFirstName,
    };
  },
};
</script>

<style scoped>
.attention {
  color: #e3342f;
  font-size: 1rem;
}
</style>
